import axios from "axios"
import { Turno } from "../pages/Agendamento"

const URLConfiguracoesEstabelecimentos =
    "https://pfrqecv4rpl4kq3ii6uixxx2jy0gczni.lambda-url.us-east-1.on.aws/api"
// window.location.href.includes("localhost")
//     ? "http://localhost:3001/api"
//     : "https://7gbutnuxrrsp5cdhw34j6h26zm0pxkbm.lambda-url.us-east-1.on.aws/api"

const apiConfiguracoesEstabelecimentos = axios.create({
    baseURL: URLConfiguracoesEstabelecimentos,
})

export async function getTurnosAgendamento(idEstabelecimento: number) {
    const Authorization = localStorage.getItem("chaveSistema")

    const response = await apiConfiguracoesEstabelecimentos.get(
        `/periodo/buscar/${idEstabelecimento}`,
        {
            headers: { Authorization },
        }
    )

    return response.data
}

export async function salvarTurnosAgendamento(data: Turno[], idEstabelecimento: number) {
    const Authorization = localStorage.getItem("chaveSistema")

    const response = await apiConfiguracoesEstabelecimentos.patch(
        `/periodo/atualizar/${idEstabelecimento}`,
        data.map(t => ({ ...t, id: t.id > 0 ? t.id : undefined })),
        {
            headers: { Authorization },
        }
    )

    return response.data as Turno[]
}

export async function excluirTurnosAgendamento(data: Turno[], idEstabelecimento: number) {
    const Authorization = localStorage.getItem("chaveSistema")

    const response = await apiConfiguracoesEstabelecimentos.post(
        `/periodo/excluir/${idEstabelecimento}`,
        data,
        {
            headers: { Authorization },
        }
    )

    return response.data
}
